import { render } from "./HabitationsComponent.vue?vue&type=template&id=864b115a"
import script from "./HabitationsComponent.vue?vue&type=script&lang=js"
export * from "./HabitationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__